import React from 'react';

import { deriveFormattedDateRange } from '~support-at-home/lib/derive';

import Icon, { faCalendar } from '~components/icon';

interface ComponentProps {
  start_date: string;
  end_date: string;
  title?: string;
}

const DateRange: React.FC<ComponentProps> = ({ start_date, end_date, title }) => {
  return (
    <div className="d-flex align-items-center bg-light rounded p-3 mb-3">
      <Icon icon={faCalendar} className="text-secondary me-3" />

      <div className="d-flex flex-column">
        {title && <h6 className="fw-semibold text-muted mb-1">{title}</h6>}
        <span className="fw-medium">{deriveFormattedDateRange({ start_date, end_date })}</span>
      </div>
    </div>
  );
};

export default DateRange;
